import { render, staticRenderFns } from "./SummarySectionZoom.vue?vue&type=template&id=65ea8f4e&scoped=true"
import script from "./SummarySectionZoom.vue?vue&type=script&lang=js"
export * from "./SummarySectionZoom.vue?vue&type=script&lang=js"
import style0 from "./SummarySectionZoom.vue?vue&type=style&index=0&id=65ea8f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ea8f4e",
  null
  
)

export default component.exports